import { ExclamationCircleOutlined } from "@ant-design/icons";
import React from 'react';
import { NavLink } from "react-router-dom";
import styles from "./style.module.scss";

export enum ErrorName {
    Route = 'route',
    DeliveryTypes = 'delivery_types',
    FishAmount = 'fish_amount',
    DeliveryId = 'delivery_id',
    DestinationId = 'destination_id',
    Duration = 'duration',
    TaskType = 'task_type',
    Location = 'location',
    TYPE = 'type'                       // Service task type
}

const errorView: { [id: string]: React.FC<{ value: any }> } = {
    [ErrorName.Route]: ({ value }: any) => value.map((item: any, index: number) => <div className={styles['error-line']}
        key={index}>
        {item.message}.
        <NavLink className={styles.url}
            to={`/route?source=${item.source_id}&destination=${item.destination_id}`}>
            Create one
        </NavLink>
    </div>),
    [ErrorName.DeliveryTypes]: ({ value }: any) => <>
        {Object.keys(value).map(key => <div className={styles['error-line']} key={key}>
            {value[key]?.message}
        </div>)}
    </>,
    [ErrorName.Duration]: ({ value }) => {
        return <div className={styles['error-line']} dangerouslySetInnerHTML={{ __html: value.message }} />
    }
}

const Default: React.FC = ({ value }: any) => {
    const result = value.message || value;

    return <div>
        {typeof result === "string" ? result : ""}
    </div>
}

interface IProps {
    error_detail?: ({
        [id: string]: string | { message: string }
    } & {
        [ErrorName.Route]?: { source_id: string, destination_id: string, message: string }[],
        [ErrorName.DeliveryTypes]?: { [id: string]: { message: string } }
    })
    style?: any
}

const ErrorOfOperation: React.FC<IProps> = ({ error_detail = {}, style = {} }) => {
    const count = Object.keys(error_detail).length;
    const isError = count > 0;

    return <div className={styles['error-message']} data-show={isError} style={style}>
        <div className={styles.icon}><ExclamationCircleOutlined /></div>
        <div>
            {Object.keys(error_detail).map(key => {
                const { [key]: View = Default } = errorView;

                return <View key={key} value={error_detail[key]} />
            })}
        </div>
    </div>;
};

export default ErrorOfOperation;

